@file:OptIn(androidx.compose.ui.ExperimentalComposeUiApi::class, InternalRichTextApi::class)

package com.taocent.simple.compose.component.richtext.core.internal.platform

import androidx.compose.runtime.Composable
import com.taocent.simple.compose.component.richtext.core.InternalRichTextApi
import com.taocent.simple.compose.component.richtext.core.RichTextState

/**
 * js 平台实现 — 普通富文本 web 端 IME 拦截的简化版。
 *
 * 暂不做 DOM 级别 `paste` event capture listener 拦截,因为:
 * - 普通富文本 web 端 Cmd/Ctrl+V 的「keydown 主动 paste + native paste event
 *   重复粘贴」问题涉及 [RichTextState.suppressNextNativePasteEvent] flag 注入
 *   + [com.taocent.simple.compose.component.richtext.core.internal.ui.RichTextKeyEventHandler]
 *   协调 + capture listener 注册,属于 web 端粘贴修复专题(超出当前任务范围)。
 * - 普通富文本的 `RichTextKeyEventHandler` 已调 `markSuppressedImePasteOnNextValueChange()`
 *   吞掉 iOS / 旧 Android 路径的 `onValueChange` 重复,web 端**不**受影响
 *   (web 端 native paste 走 contentEditable 内部,**不**走 `onValueChange`)，
 *   这是 web 端独有的双层协调问题,需要单独修复。
 *
 * 当前简化版只做 no-op,直接渲染 [content],让 Android / iOS 软键盘 IME 路径
 * 走 core 的 [InterceptImePasteTextInput] 拦截。后续可在 [RichTextState] 上
 * 加 `suppressNextNativePasteEvent` flag 配合 capture listener 完整修复 web 端
 * 重复粘贴。
 */
@OptIn(androidx.compose.ui.ExperimentalComposeUiApi::class, InternalRichTextApi::class)
@Composable
actual fun InterceptImePasteTextInput(
    richTextState: RichTextState,
    onPasteJson: ((String) -> Boolean)?,
    content: @Composable () -> Unit
) {
    content()
}
